// extracted by mini-css-extract-plugin
export default {"Container":"MappingTypeActionButton_Container__cQuMH","Row":"MappingTypeActionButton_Row__TU8Ro"};